import { Injectable, signal, computed, WritableSignal } from '@angular/core';

import { AuthenticationService } from 'src/app/core/providers/services/authentication.service';
import { FeatureFlagService } from '../../feature-flags/feature-flag.service';

/**
 * Manages Filter Profiles.
 */
@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  public isUserInfoLoaded = signal(false);
  public hasOperatedData: WritableSignal<boolean> = signal(false);
  public shouldShowFilters: WritableSignal<boolean> = signal(false);

  constructor(
    public authService: AuthenticationService,
    private featureFlagService: FeatureFlagService
  ) {
    this.authService.userInfoSubject.subscribe((value) => {
      console.log('permissions.service.userInfoSubject ', value);
      if (value) {
        this.isUserInfoLoaded.set(true);
        if (
          this.authService.selectedClientId() &&
          this.authService.userInfoView
        ) {
          const client = this.authService.userInfoView?.SelectedClient;
          console.log('       client  ', client);
          if (client) {
            this.hasOperatedData.set(client.HasOperatedData);
            this.shouldShowFilters.set(client.HasOperatedData);
          }
        }
      }
    });
  }
}
